module.exports = __webpack_public_path__ + "img/hans-granerud-p.87355f6b.jpg";